import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApButtonComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';
import { ApColComponent, ApRowComponent } from '@ap/grid';
import { ApIllustrationComponent } from '@ap/illustration';

import { ErrorComponent } from './error.component';

/**
 * @ngdoc module
 * @name ErrorModule
 **/
@NgModule({
    imports: [
        ApButtonComponent,
        ApContentModule,
        ApIllustrationComponent,
        ApRowComponent,
        ApColComponent,
        CommonModule,
        ReactiveFormsModule
    ],
    declarations: [ErrorComponent],
    exports: [ErrorComponent]
})
export class ErrorModule {}
